jQuery(document).ready(function($) {
    $('#load-more-posts').on('click', function() {
        const button = $(this);
        let page = parseInt(button.data('page'));
        const maxPages = parseInt(button.data('max'));
        const perPage = parseInt(button.data('perpage'));

        if (page >= maxPages) {
            button.hide();
            return;
        }

        page++;
        button.data('page', page);
        button.text('Loading...');

        $.ajax({
            url: MyAjax.ajaxurl, // Use localized ajaxurl here
            type: 'POST',
            data: {
                action: 'load_more_community_posts',
                page: page,
                perpage: perPage,
            },
            success: function(response) {
                if (response.success) {
                    $('#community-posts-grid').append(response.data.html);
                    if (page >= maxPages) {
                        button.hide();
                    } else {
                        button.text('Load More');
                    }
                } else {
                    button.hide();
                }
            },
            error: function() {
                button.text('Load More');
            }
        });
    });
});